import http from '@/utils/http'

const AVAILABLE_SCOPES = [
  'public',
  'promotion',
  'private'
]

const OFFER_TYPES = [
  'prepaid_minute',
  'mail',
  'service',
  'product',
  'availability'
]

const isOfferScope = scope => AVAILABLE_SCOPES.indexOf(scope) >= 0

const isContentScope = scope => !isOfferScope(scope)

const isOfferType = type => OFFER_TYPES.indexOf(type) >= 0

const fetchAll = ({ scope }) => {
  if (isOfferScope(scope)) {
    return http().get(`/${scope}_offers`)
  } else {
    return http().get(`/custom_offers/${scope}`)
  }
}

const get = ({ id }) => http()
  .get(`/offers/${id}`)

const update = ({ id, data }) => http()
  .put(`/offers/${id}`, data)

const create = ({ data }) => http()
  .post(`/offers`, data)

const remove = ({ id }) => http()
  .delete(`/offers/${id}`)

export default {
  AVAILABLE_SCOPES,
  OFFER_TYPES,
  isOfferScope,
  isContentScope,
  isOfferType,
  fetchAll,
  get,
  update,
  create,
  remove
}



// WEBPACK FOOTER //
// ./src/api/service.js